import React from "react";
import Button from "./Button";
import Tooltip from "./Tooltip";

const ListItemClass = props => {
    const {clazz, inClass, onClick} = props;

    return (
        <tr>
            <td>{clazz.className}</td>
            <td>{clazz.classCode}</td>
            <td className={'ch-align-center'}>{clazz.totalStudents}</td>
            <td className={'ch-align-center'}>
                <Button type={'text'} onClick={onClick}>
                    {inClass ? 'Remove' : 'Add'}
                </Button>
            </td>
        </tr>
    )
}

export default ListItemClass;